<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  }
})

const height = computed(() => props.height ? props.height : 41)
const width = computed(() => height.value * 213 / 207)

</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 213 207" xmlns="http://www.w3.org/2000/svg"
       xml:space="preserve"
       style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-75.0131,-33.9741)">
        <g transform="matrix(1,0,0,1,25.8905,-68.6369)">
            <g id="g859" transform="matrix(3.53012,0,0,3.53012,-25.8902,68.6513)">
                <path id="path849"
                      d="M51.33,68.08C67.7,68.31 81.16,55.23 81.4,38.86C81.16,22.49 67.7,9.41 51.33,9.64C34.95,9.41 21.49,22.49 21.25,38.86C21.49,55.23 34.95,68.31 51.33,68.08Z"
                      style="fill:rgb(255,200,0);fill-rule:nonzero;"/>
              <path id="path851"
                    d="M64.27,60.63C54.06,66.36 42.98,67.38 35.9,63.95C45.31,69.38 56.88,69.47 66.37,64.17C75.74,59.01 81.52,49.12 81.41,38.43C80.93,46.09 74.48,54.9 64.27,60.63Z"
                    style="fill-rule:nonzero;"/>
              <path id="path853"
                    d="M55.14,11.78C57.21,15.26 52.21,21.84 43.96,26.46C35.71,31.09 27.35,32.01 25.28,28.52C25.19,28.35 25.11,28.17 25.05,27.99C24.66,25.86 25.27,23.68 26.7,22.06C26.95,21.71 27.21,21.37 27.47,21.04C29.89,17.99 32.88,15.44 36.28,13.55C39.7,11.63 43.47,10.38 47.36,9.88C47.8,9.82 48.23,9.77 48.65,9.74C50.82,9.35 53.05,9.92 54.76,11.31C54.91,11.46 55.03,11.62 55.14,11.78Z"
                    style="fill-rule:nonzero;"/>
              <path id="path855"
                    d="M67.93,15.55C71.55,21.63 64.25,32.3 51.64,39.37C39.03,46.44 25.87,47.25 22.26,41.17C21.66,40.15 21.32,39 21.27,37.81C21.11,41.99 21.88,46.15 23.52,50C23.77,50.59 24.05,51.17 24.34,51.75L24.38,51.82C25.51,53.67 27.14,55.17 29.09,56.13C36.17,59.81 48.13,58.55 59.32,52.27C70.49,46 77.6,36.57 77.87,28.78C77.98,26.65 77.46,24.53 76.39,22.68C75.98,22.08 75.56,21.5 75.11,20.95C72.49,17.67 69.21,14.99 65.49,13.07C66.48,13.69 67.32,14.54 67.93,15.55L67.94,15.56L67.93,15.55Z"
                    style="fill-rule:nonzero;"/>
            </g>
        </g>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
